import { Component, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Product } from 'app/entities';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';
import { Subject } from 'rxjs';
import { openCatalogFormDialog } from '../catalog-form-dialog/catalog-form-dialog.component';

// Botão "Novo Produto": abre o cadastro em diálogo (antes era um mat-menu).
@Component({
  selector: 'app-card-drop-down-product-create',
  templateUrl: './card-drop-down-product-create.component.html',
})
export class CardDropDownProductCreateComponent {

  @Output() onCreated = new Subject<Product>();
  @Input() responsiveBtn = false;
  // Só ícone (ex.: criar dentro de um select): recebe aria-label e tooltip
  @Input() iconOnly = false;
  readonly label = 'Novo produto';
  @Input() appearance: string = 'standard';
  @Input('showStatusInput') showStatusInput: boolean = true;

  constructor(
    private _subscriptionRestrictionService: SubscriptionRestrictionService,
    private _dialog: MatDialog,
  ) { }

  onClick(event: Event) {
    event.stopPropagation();
    this.open();
  }

  open() {
    if (this._subscriptionRestrictionService.checkFeatureLimitAndShowDialog("produtos-e-servicos")) {
      return;
    }
    openCatalogFormDialog<Product>(this._dialog, { kind: 'product', showStatusInput: this.showStatusInput })
      .subscribe((result) => {
        if (result?.action === 'created') {
          this.onCreated.next(result.value);
        }
      });
  }

}
